
/**
 * Renders the svg icon for the Safa logo.
 */
export default {
  name: "SafaLogo",
};
